import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-goal-status-chip',
  templateUrl: './goal-status-chip.component.html',
})
export class GoalStatusChipComponent {
  @Input() status: 'draft' | 'sent' | 'approved' | 'rejected' | string;
  @Input() label: string = "";
  @Input() isFull: boolean = false;
}
